module.exports = __webpack_public_path__ + "static/media/kaolin.8b3f5097.jpg";